import Swal from "sweetalert2";

export const popupAlert = (icon, title, message) => {
  Swal.fire({
    icon: icon,
    title: title,
    text: message,
  });
};
